module.exports = __webpack_public_path__ + "img/MO.5b746dd3.svg";